import { render, staticRenderFns } from "./BlogsList.vue?vue&type=template&id=c938249e&scoped=true&"
import script from "./BlogsList.vue?vue&type=script&lang=js&"
export * from "./BlogsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c938249e",
  null
  
)

export default component.exports